module.exports = __webpack_public_path__ + "ead16a7261a306afac68d9478a4db785.png";